{
  "chat": {
    "title": "Chat",
    "empty": "Ainda não há conversas",
    "loadError": "Não foi possível carregar esta conversa",
    "messagePlaceholder": "Mensagem",
    "typing": "{{name}} está digitando…",
    "typingTwo": "{{a}} e {{b}} estão digitando…",
    "typingMany": "Várias pessoas estão digitando…",
    "online": "Online",
    "offline": "Offline",
    "unread": "Não lida",
    "startDm": "Enviar mensagem para {{name}}",
    "members": "Membros",
    "mute": "Silenciar esta conversa",
    "unmute": "Reativar o som desta conversa",
    "muted": "Silenciada"
  },
  "login": {
    "title": "Bem-vindo de volta!",
    "description": "Digite seu endereço de email e enviaremos um código para você entrar.",
    "input": {
      "label": "Endereço de email",
      "placeholder": "me@email.com"
    },
    "button": {
      "label": "Solicitar código",
      "loading": "Enviando código..."
    }
  },
  "verify": {
    "title": "Digite o código",
    "description": "Digite o código que enviamos por email para {{email}}.",
    "input": {
      "label": "Código de verificação",
      "placeholder": "00000000"
    },
    "button": {
      "label": "Verificar código",
      "loading": "Verificando código..."
    },
    "buttonAbort": {
      "label": "Cancelar"
    },
    "buttonResend": {
      "label": "Reenviar código"
    },
    "error": {
      "Invalid or expired OTP.": "O código expirou ou é inválido.",
      "invalidOtp": "O código expirou ou é inválido."
    }
  },
  "date": "{{value, datetime}}",
  "auth": {
    "logout": {
      "button": "Sair",
      "confirmTitle": "Sair",
      "confirmMessage": "Tem certeza de que deseja sair?",
      "error": "Falha ao sair. Tente novamente."
    }
  },
  "errors": {
    "types": {
      "authentication": "Erro de autenticação",
      "network": "Problema de conexão",
      "generic": "Algo deu errado"
    },
    "messages": {
      "sessionExpired": "Sua sessão expirou. Faça login novamente.",
      "networkError": "Verifique sua conexão com a internet e tente novamente.",
      "genericError": "Ocorreu um erro inesperado. Você pode tentar atualizar a página ou sair.",
      "noOrg": "Nenhuma organização encontrada..."
    },
    "technical": {
      "title": "Detalhes técnicos:",
      "retryAttempts": "Tentativas: {{current}}/{{max}}"
    },
    "actions": {
      "tryAgain": "Tentar novamente",
      "loginAgain": "Entrar novamente",
      "logout": "Sair",
      "moreOptions": "Mais opções",
      "chooseAction": "Escolha uma ação:",
      "refreshApp": "Atualizar app",
      "debugData": "Dados de depuração",
      "clearCacheRetry": "Limpar cache e tentar novamente"
    }
  },
  "common": {
    "currency": "{{value, currency}}",
    "decimalSeparator": ",",
    "loading": "Carregando...",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "error": "Erro",
    "success": "Sucesso",
    "time": {
      "dayAgo": "1 dia atrás",
      "daysAgo": "{{count}} dias atrás",
      "weekAgo": "1 semana atrás",
      "weeksAgo": "{{count}} semanas atrás",
      "monthsAgo": "{{count}} meses atrás",
      "secondsAbbr": "s"
    },
    "profile": "Perfil"
  },
  "dashboard": {
    "error": {
      "orgNotFound": "Organização não encontrada"
    },
    "quickActions": {
      "media": {
        "title": "Todas as mídias",
        "subtitle": "Navegar na biblioteca"
      },
      "achievements": {
        "title": "Conquistas",
        "subtitle": "Ver progresso"
      },
      "profile": {
        "title": "Cartão de membro",
        "subtitle": "Seus dados"
      },
      "membership": {
        "title": "Assinatura",
        "subtitle": "Ver plano"
      },
      "offers": {
        "title": "Ofertas",
        "subtitle": "Navegar disponíveis"
      },
      "invite": {
        "title": "Convidar membros",
        "subtitle": "Criar código QR"
      }
    },
    "sections": {
      "featuredVideos": "Vídeos em destaque",
      "lastViewed": "Vistos recentemente",
      "bookmarkedVideos": "Itens salvos",
      "recentAchievements": "Conquistas recentes",
      "viewAllAction": "Ver tudo"
    }
  },
  "membership": {
    "paymentRequired": {
      "title": "Configuração de pagamento necessária",
      "subtitle": "Sua assinatura foi transferida para esta organização. Para continuar, configure seu pagamento com um dos métodos de pagamento disponíveis.",
      "paidUntilNote": "Seu período já pago é mantido — você não será cobrado antes de {{date}}.",
      "bonusOffer_one": "Configure seu pagamento até {{date}} e ganhe {{count}} mês de bônus grátis.",
      "bonusOffer_other": "Configure seu pagamento até {{date}} e ganhe {{count}} meses de bônus grátis.",
      "openDashboard": "Configurar o pagamento no painel web",
      "openDashboardHint": "Por motivos de segurança, a configuração do pagamento acontece no seu navegador. Você será conectado automaticamente.",
      "checkAgain": "Concluí o pagamento",
      "error": "Não foi possível iniciar a configuração do pagamento. Tente novamente."
    },
    "codeOfConduct": {
      "heading": "Código de conduta",
      "subtitle": "Leia o texto a seguir e aceite-o para continuar usando esta organização.",
      "acceptLabel": "Li e aceito “{{title}}”.",
      "accept": "Aceitar",
      "acceptError": "Não foi possível salvar seu consentimento. Tente novamente.",
      "loadError": "Não foi possível carregar o texto.",
      "retry": "Tentar novamente",
      "newVersion": "Uma nova versão está em vigor agora. Leia-a e aceite-a."
    },
    "title": "Assinatura",
    "status": {
      "active": "Ativa",
      "inactive": "Inativa"
    },
    "period": {
      "monthly": "Mensal",
      "yearly": "Anual"
    },
    "pricing": {
      "per": {
        "monthly": "por mês",
        "yearly": "por ano"
      }
    },
    "sections": {
      "planDetails": "Detalhes",
      "organization": "Organização"
    },
    "labels": {
      "billingPeriod": "Período de cobrança",
      "memberSince": "Membro desde",
      "validUntil": "Válido até",
      "cancelled": "Assinatura cancelada"
    },
    "organization": {
      "memberDescription": "Você é membro desta organização"
    },
    "management": {
      "title": "Gerenciar sua assinatura",
      "description": "Para fazer alterações na sua assinatura, use o WebApp OctaHub ou entre em contato diretamente com {{organizationName}}."
    },
    "dashboard": {
      "title": "Abrir painel",
      "subtitle": "Gerencie sua assinatura e configurações",
      "openError": "Não foi possível abrir o painel. Tente novamente."
    }
  },
  "media": {
    "download": {
      "button": "Baixar",
      "available": "Disponível offline"
    },
    "screens": {
      "bookmarks": "Vídeos salvos",
      "lastViewed": "Vídeos vistos recentemente",
      "library": "Mídia"
    },
    "bookmark": {
      "save": "Salvar",
      "saved": "Salvo",
      "bookmarkLabel": "Favorito",
      "bookmarkedLabel": "Salvo"
    },
    "folder": {
      "itemCount_one": "{{count}} item",
      "itemCount_other": "{{count}} itens",
      "folderDescription": "Pasta com {{count}} itens"
    },
    "sharedFolders": {
      "upload": "Enviar",
      "newFolder": "Nova pasta",
      "folderNamePlaceholder": "Nome da pasta...",
      "uploading": "Enviando...",
      "uploadProgress": "{{progress}}%",
      "uploadSuccess": "Arquivo enviado com sucesso",
      "uploadError": "Falha no envio",
      "uploadErrorMessage": "Ocorreu um erro durante o envio. Tente novamente.",
      "uploadSubtitle": "Enviar um arquivo para esta pasta",
      "newFolderSubtitle": "Criar uma nova subpasta"
    },
    "navigation": {
      "previous": "Anterior",
      "next": "Próximo"
    },
    "relatedVideos": "Conteúdo relacionado",
    "delete": {
      "button": "Excluir",
      "confirmTitle": "Excluir mídia",
      "confirmMessage": "Tem certeza de que deseja excluir este item? Esta ação não pode ser desfeita.",
      "success": "Mídia excluída com sucesso",
      "error": "Falha ao excluir",
      "errorMessage": "Não foi possível excluir esta mídia. Tente novamente.",
      "errorInUse": "Esta mídia é usada em uma ou mais ofertas e não pode ser excluída."
    }
  },
  "achievements": {
    "title": "Conquistas",
    "subtitle": "Suas conquistas obtidas",
    "count_zero": "Nenhuma conquista obtida",
    "count_one": "{{count}} conquista obtida",
    "count_other": "{{count}} conquistas obtidas",
    "earned": "Obtido {{time}}",
    "emptyState": {
      "title": "Nenhuma conquista ainda",
      "description": "Complete cursos e atividades para obter sua primeira conquista!"
    }
  },
  "noOrg": {
    "title": "Nenhuma organização encontrada",
    "description": "Você ainda não tem acesso a nenhuma organização. Entre em contato com seu administrador para obter acesso ou tente novamente mais tarde.",
    "actions": {
      "title": "O que você pode fazer:",
      "contactAdmin": "Entrar em contato com o administrador da sua organização",
      "askInvitation": "Solicitar um convite",
      "checkAccount": "Verificar se está usando a conta correta",
      "tryRelogin": "Tentar sair e entrar novamente"
    }
  },
  "offers": {
    "title": "Ofertas",
    "detailsTitle": "Detalhes da oferta",
    "notFound": "Oferta não encontrada",
    "notFoundMessage": "Esta oferta não foi encontrada",
    "noOffers": "Nenhuma oferta disponível no momento",
    "purchased": "Comprado",
    "free": "Grátis",
    "purchaseWebOnly": "Compra apenas no web-app",
    "claimOffer": "Resgatar oferta",
    "purchase": "Comprar",
    "purchasedBadge": "✓ Você já possui esta oferta",
    "youOwnThis": "Você tem acesso a todo o conteúdo desta oferta",
    "missingAchievements": "⚠️ Você não possui as conquistas necessárias para esta oferta. Ainda falta: {{missing}}",
    "mobileNotAvailable": "⚠️ Compras não estão disponíveis no app móvel",
    "mobileNotAvailableSubtext": "Visite nosso site para comprar esta oferta",
    "price": "Preço:",
    "includedContent": "Conteúdo incluído",
    "includedAchievements": "Conquistas incluídas",
    "videoCount_one": "{{count}} vídeo",
    "videoCount_other": "{{count}} vídeos",
    "audioCount_one": "{{count}} áudio",
    "audioCount_other": "{{count}} áudios",
    "pdfCount_one": "{{count}} PDF",
    "pdfCount_other": "{{count}} PDFs",
    "documentCount_one": "{{count}} documento",
    "documentCount_other": "{{count}} documentos",
    "imageCount_one": "{{count}} imagem",
    "imageCount_other": "{{count}} imagens",
    "achievementCount_one": "{{count}} conquista",
    "achievementCount_other": "{{count}} conquistas",
    "paymentDenied": {
      "title": "Pagamento indisponível",
      "description": "Esta oferta não está disponível para compra na sua região"
    },
    "pricing": {
      "netAmount": "Valor líquido"
    },
    "errors": {
      "general": "Erro",
      "purchaseFailed": "Falha ao processar a compra",
      "webOnly": "Compras estão disponíveis apenas na versão web"
    },
    "success": {
      "claimed": "Oferta resgatada com sucesso!"
    },
    "paymentProviders": {
      "selectTitle": "Selecionar método de pagamento",
      "selectSubtitle": "Escolha como deseja pagar",
      "stripe": {
        "name": "Stripe",
        "description": "Cartão de crédito, cartão de débito, Apple Pay, Google Pay"
      },
      "paypal": {
        "name": "PayPal",
        "description": "Saldo PayPal, cartão de crédito, conta bancária"
      }
    },
    "payment": {
      "processing": "Processando seu pagamento...",
      "success": {
        "title": "Pagamento realizado com sucesso!",
        "message": "Sua compra foi concluída com sucesso. Agora você tem acesso ao conteúdo.",
        "viewOffer": "Ver oferta",
        "backToOffers": "Voltar às ofertas"
      },
      "pending": {
        "title": "Pagamento em processamento",
        "message": "Seu pagamento ainda está sendo processado. Isso pode levar alguns instantes...",
        "checkStatus": "Verificar status"
      },
      "failed": {
        "title": "Pagamento falhou",
        "message": "Seu pagamento não pôde ser concluído. Tente novamente.",
        "tryAgain": "Tentar novamente"
      }
    }
  },
  "orgSelection": {
    "title": "Selecionar organização",
    "subtitle": "Escolha uma organização para continuar",
    "switchOrg": "Trocar organização",
    "switchOrgSubtitle": "Mudar para outra organização",
    "currentOrg": "Atual"
  },
  "profile": {
    "myPurchases": "Minhas compras",
    "idPrefix": "ID: "
  },
  "settings": {
    "language": {
      "title": "Idioma",
      "subtitle": "Selecione seu idioma preferido",
      "systemDefault": "Padrão do sistema"
    },
    "notifications": {
      "title": "Notificações",
      "subtitle": "Escolha sobre o que você quer ser notificado",
      "chat": "Mensagens do chat",
      "chatHint": "Receba notificações de novas mensagens nas suas conversas",
      "seeAll": "Ver todas as notificações",
      "permissionDenied": "As notificações deste aplicativo estão desativadas nas configurações do seu dispositivo."
    }
  },
  "openWebApp": "Abrir Web App",
  "openWebAppSubtext": "Gerencie sua conta, compras e mais em {{url}}",
  "openWebAppError": "Não foi possível abrir o web app. Tente novamente.",
  "invite": {
    "title": "Convidar membros",
    "selectPlan": "Selecionar um plano de assinatura",
    "selectGroup": "Selecionar um grupo",
    "generating": "Gerando...",
    "scanToJoin": "Escaneie este código QR para participar",
    "createAnother": "Criar outro",
    "error": {
      "createFailed": "Não foi possível criar o convite. Tente novamente.",
      "noPlans": "Nenhum plano de assinatura disponível."
    }
  },
  "notifications": {
    "title": "Notificações",
    "empty": "Ainda não há notificações",
    "markAllRead": "Marcar todas como lidas",
    "unread": "Não lida",
    "loadError": "Não foi possível carregar as notificações",
    "chat": {
      "messageGroup": {
        "title": "{{channel}}",
        "body": "{{sender}}: {{preview}}"
      },
      "messageDm": {
        "title": "{{sender}}",
        "body": "{{preview}}"
      }
    },
    "common": {
      "newMessage": "Nova mensagem"
    }
  }
}
